import { connect } from 'react-redux'

import { selectIntegrationSettingsForProvider } from 'ducks/integrations'

import IntegrationActionContentJiraCloud from '../IntegrationActionContentJiraCloud/view'

export default connect(state => ({
  provider: 'jira_server',
  settings: selectIntegrationSettingsForProvider(state, {
    provider: 'jira_server',
  }),
}))(IntegrationActionContentJiraCloud)
